"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var StackToolbar_shared_exports = {};
__export(StackToolbar_shared_exports, {
  appendStackToolbarConfig: () => appendStackToolbarConfig,
  exposeStackToolbarConfig: () => exposeStackToolbarConfig
});
module.exports = __toCommonJS(StackToolbar_shared_exports);
var optionKeys = {
  left: "__oneStackToolbarLeft",
  right: "__oneStackToolbarRight",
  bottom: "__oneStackToolbarBottom"
};
function appendStackToolbarConfig(options, props) {
  var _props_placement;
  return {
    ...options,
    [optionKeys[(_props_placement = props.placement) !== null && _props_placement !== void 0 ? _props_placement : "bottom"]]: props
  };
}
function exposeStackToolbarConfig(options) {
  var toolbar = {
    left: options[optionKeys.left],
    right: options[optionKeys.right],
    bottom: options[optionKeys.bottom]
  };
  if (!toolbar.left && !toolbar.right && !toolbar.bottom) return options;
  var { [optionKeys.left]: _left, [optionKeys.right]: _right, [optionKeys.bottom]: _bottom, ...publicOptions } = options;
  return {
    ...publicOptions,
    toolbar
  };
}
//# sourceMappingURL=StackToolbar.shared.js.map
